import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { isFeatureActive } from '@helpers';
import { BodyText } from 'palette/Typography';
import { useActiveDeal } from '@common/ActivateDeals/hooks';
import { useConfig } from '@common/Hooks/useConfig';
import { useTranslate } from '@common/Translations';
import { isBooztletAndWebshop } from '@helpers/env';

function ActivateDealsTag({ prices }) {
    const translate = useTranslate();
    const deal = useActiveDeal();
    const config = useConfig();
    const {
        product
    } = useSelector(state => ({ product: state.product }));

    const { current } = product;
    const { ean_id: eanId } = current;
    const { price = null, name = '' } = prices?.[eanId] || {};

    const [mdvPrice, mdvName] = translate('mdv.{%price%}_with_{%name%}', { price: `${price}$%`, name })
        .split(/\$%/).filter(e => e);

    if (deal?.activated !== true && price && !isFeatureActive('PLT-1624_volume_discount', config)) {
        return (
            <div className={classNames('p-card__activate-deals-tag', {
                'p-card__activate-deals-tag--booztlet': isBooztletAndWebshop(config)
            })}
            >
                <div
                    className="p-card__activate-deals-tag__info"
                    style={{
                        backgroundColor: deal?.banner_color
                    }}
                >
                    <BodyText>{mdvPrice}</BodyText>
                    <BodyText>{mdvName}</BodyText>
                </div>
            </div>
        );
    }

    return null;
}

export default ActivateDealsTag;
